function intiAccordionHeaderMenu() {
  const btns = document.querySelectorAll(".header-menu ul div a svg");

  btns.forEach(function (btn) {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      const parent = btn.closest("div");
      const content = parent.querySelector("div");

      const isOpen = btn.classList.toggle("is-active");

      if (isOpen) {
        content.style.maxHeight = content.scrollHeight + "px";
      } else {
        content.style.maxHeight = 0;
      }
    });
  });
}

export { intiAccordionHeaderMenu };
